// @flow
export const ADDRESS_TYPE_PRIMARY = 'primaryAddress'
export const ADDRESS_TYPE_POST = 'mailAddress'
export const ADDRESS_TYPE_VISIT = 'visitAddress'
export type AddressType = 'visitAddress' | 'mailAddress' | 'primaryAddress'
export const Mapping = {
  primaryAddress: 'primaryAddress',
  mailAddress: 'postAddress',
  visitAddress: 'visitAddress'
}



// WEBPACK FOOTER //
// ./src/types/address-type.js